<template>
  <BasicLayout>
    <template #wrapper>
      <el-card :bordered="false" :body-style="{padding: '0'}">
        <div class="salesCard">
          <el-form :inline="true">
            <el-form-item label="登录方式" prop="adChannel">
              <el-select v-model="queryParams.adChannel" style="width: 125px" filterable placeholder="请选择">
                <el-option
                  v-for="item in adChannel"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="开始日期">
              <el-date-picker
                v-model="queryParams.startDate"
                placeholder="请选择日期"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                style="width: 150px"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="结束日期">
              <el-date-picker
                v-model="queryParams.endDate"
                placeholder="请选择日期"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                style="width: 150px"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-button :loading="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
              <el-button v-if="exportShow" type="primary" icon="el-icon-search" size="mini" @click="exportData">导出</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getSubVipStat } from '@/api/statistics/user_remain'
import echarts from 'echarts'
import { dateStrTodate, getLastDates } from '@/utils'

export default {
  name: 'IndexSubVip',
  props: {
    startDate: {
      type: String,
      default: ''
    },
    endDate: {
      type: String,
      default: ''
    },
    exportShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      platForm: [{ label: '全部', value: 0 }, { label: '安卓', value: 1 }, { label: '苹果', value: 2 }, { label: 'TG', value: 3 }],
      adChannel: [{ label: '全部', value: '' }, { label: '游客', value: 'GUEST' }, { label: 'FACEBOOK', value: 'FACEBOOK' }, { label: '苹果', value: 'APPLE' }, { label: '谷歌', value: 'GOOGLE' }],
      country: [],
      chartData: {},
      queryParams: {
        platForm: '',
        country: '',
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        adChannel: '',
        type: 1
      },
      options: [],
      tableData: [],
      date: [],
      chart: {},
      option: {}
    }
  },
  watch: {
    startDate(newVal, oldVal) {
      this.getTables()
    }
  },
  created() {
    this.queryParams.startDate = getLastDates(7)
    this.queryParams.endDate = getLastDates(1)
    this.getTables()
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleKeyUp() {
      this.onSubmit()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能与结束日期')
        return
      }

      this.getTables()
    },
    getTables() {
      this.loading = true
      this.queryParams.type = 1
      getSubVipStat(this.queryParams).then(res => {
        this.loading = false
        this.chart.hideLoading()
        if (res.code === 200) {
          const echartData = {
            date: [],
            orderCount: [],
            successCount: [],
            cancleCount: [],
            rate: [],
            cancleRate: [],
            renewalRate: []
          }
          res.data.data.forEach(item => {
            echartData.date.push(dateStrTodate(item.date))
            echartData.orderCount.push(item.order_count)
            echartData.successCount.push(item.success_count)
            echartData.cancleCount.push(item.cancel_count)
            echartData.rate.push(item.order_rate)
            echartData.cancleRate.push(item.cancel_rate)
            echartData.renewalRate.push(item.renewal_rate)
          })
          this.option.xAxis.data = echartData.date
          this.option.series[0].data = echartData.orderCount
          this.option.series[1].data = echartData.successCount
          this.option.series[2].data = echartData.cancleCount
          this.option.series[3].data = echartData.rate
          this.option.series[4].data = echartData.cancleRate
          this.option.series[5].data = echartData.renewalRate
          this.chart.setOption(this.option)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    numFormatter(row, column, cellValue, index) {
      return cellValue + '%'
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.chart.showLoading()
      this.option = {
        title: {
          text: 'Vip订阅'
        },
        xAxis: {
          name: '',
          type: 'category',
          data: []
        },
        legend: {
          data: ['下单数', '成功数量', '取消数量', '成功率', '取消率', '续费率'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [
          { type: 'value', axisLabel: { formatter: '{value}' }, axisLine: {
            show: false // 隐藏 y 轴的竖线
          }},
          { type: 'value', axisLabel: { formatter: '{value}%' }, position: 'right', axisLine: {
            show: false // 隐藏 y 轴的竖线
          }}
        ],
        toolbox: {
          show: true,
          feature: {}
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '下单数',
            data: [],
            type: 'line',
            smooth: true,
            markPoint: {},
            label: {
              show: true,
              position: 'left', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '成功数量',
            data: [],
            type: 'line',
            smooth: true,
            markPoint: {},
            label: {
              show: true,
              position: 'right', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '取消数量',
            data: [],
            type: 'line',
            smooth: true,
            markPoint: {},
            label: {
              show: true,
              position: 'right', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '成功率',
            data: [],
            type: 'line',
            smooth: true,
            markPoint: { },
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            },
            itemStyle: {
              normal: { }
            }
          }, {
            name: '取消率',
            data: [],
            type: 'line',
            smooth: true,
            markPoint: { },
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            },
            itemStyle: {
              normal: { }
            }
          },
          {
            name: '续费率',
            data: [],
            type: 'line',
            smooth: true,
            markPoint: { },
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            },
            itemStyle: {
              normal: { }
            }
          }
        ]
      }
      this.chart.setOption(this.option)
    },
    handleClick(params) {
      const clickName = params.name
      const selected = params.selected
      if (this.reelectionName === '') {
        this.reelectionName = clickName
        this.reelectionClick++
      } else if (this.reelectionName !== clickName) {
        this.resetLegend(selected)
        return
      }

      if (this.reelectionClick > 2 && this.reelectionName === clickName) {
        this.resetLegend(selected)
        return
      }

      this.reelectionClick++
      const reelection = this.reelection
      for (const i in selected) {
        if (i === clickName) {
          selected[i] = !reelection
        } else {
          selected[i] = reelection
        }
      }
      this.reelection = !reelection
      this.chart.setOption({
        legend: {
          selected: selected
        }
      })
    },
    resetLegend(selected) {
      for (const i in selected) {
        selected[i] = true
      }
      this.reelectionName = ''
      this.reelection = false
      this.chart.setOption({
        legend: {
          selected: selected
        }
      })
      this.reelectionClick = 0
    },
    exportData() {
      this.queryParams.type = -1
      getSubVipStat(this.queryParams).then(res => {
        window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
      })
    }
  }
}
</script>

<style scoped>
</style>
